import { CSS_PROPERTY, getCssBasedOnRtl, media } from '../../styles';
import styled, { DefaultTheme } from 'styled-components';

export const MenuContainer = styled.div`
  position: relative;
`;

export const MenuButton = styled.button`
  align-items: center;
  background-color: white;
  border: 1px solid ${({ theme }) => theme.typography.color.tertiary};
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.typography.size.medium};
  justify-content: space-between;
  outline: none;
  margin: 0;
  ${({ theme }): string => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_RIGHT, theme.spacing.base.xs)};
  ${({ theme }): string => getCssBasedOnRtl(theme, CSS_PROPERTY.PADDING_LEFT, theme.spacing.base.xxs)};
  padding-bottom: ${({ theme }): string => theme.spacing.base.xxs};
  padding-top: ${({ theme }): string => theme.spacing.base.xxs};

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }
`;

type SelectorProps = {
  maxHeight?: number;
};

export const Menu = styled.div<SelectorProps>`
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  max-height: ${({ maxHeight }) => maxHeight || 100}px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 2147483643;
`;

export const MenuItem = styled.button`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.typography.color.quaternary};
  font-size: ${({ theme }) => theme.typography.size.medium};
  margin: 0;
  min-height: 25px;
  outline: none;
  padding: ${({ theme }) => theme.spacing.base.xxs};

  &:hover {
    background-color: ${({ theme }) => theme.color.neutral.default};
  }

  &:focus-visible {
    outline-style: auto;
    outline-width: 5px;
  }

  ${media.mobilePortrait} {
    min-height: 35px;
  }
  ${media.mobileLandscape} {
    min-height: 35px;
  }
`;

export const TextContainer = styled.div`
  color: ${({ theme }) => theme.ui.text.color};
  padding: ${({ theme }) => `0 ${theme.spacing.base.xs}`};
`;

const arrowStyle = (theme: DefaultTheme): string => {
  return `
    border: solid ${theme.ui.text.color};
    padding: ${theme.spacing.mobile.xxs};
    border-width: 0 1.5px 1.5px 0;
    margin-bottom: ${theme.spacing.mobile.xxs};
    height: 8px;
    width: 8px;
`;
};

export const UpArrow = styled.i`
  transform: translate(0, 2.6px) rotate(-135deg);
  ${({ theme }) => arrowStyle(theme)}
`;

export const DownArrow = styled.i`
  transform: translate(0, -1.2px) rotate(45deg);
  ${({ theme }) => arrowStyle(theme)}
`;
